import React, { useEffect, useState } from 'react'
import { Button } from "reactstrap";
import httpService from "../../../services/http.service";
import WarningMessage from "../../common/warnMsg";
import SuccessMessage from "../../common/successMsg";
import Navbar from './settingNav';
import ErrorMessage from '../../common/errorMsg';

const CsvFileRefreshTime = (props) => {
    const [activeTab, setActiveTab] = useState("csvFileRefreshTime");
    const [refreshTime, setRefreshTime] = useState(0);

    useEffect(() => {
        setRefreshTime(props.refreshTime)
        getRefreshTime()
    }, [props.refreshTime])

    const handleTime = (e) => {
        if (
            e.target.value.match(/[^0-9]/) === null &&
            e.target.value.length <= 10
        ) {
            setRefreshTime(e.target.value);
        }
    };

    const getRefreshTime = async (e) => {
        const timeData = await httpService.getAll("getCsvRefreshTime")
        .catch((err) => {
            if (err && err.response && err.response.status == 401) {
              ErrorMessage("Session expired, please login again")
            }
            return;
          });
        if (timeData?.data && timeData?.data?.data) {
            setRefreshTime(timeData?.data?.data)
        } else {
            setRefreshTime('0')
        }
    }

    const saveRefreshTime = async (e) => {
        if (refreshTime === ""||refreshTime=="0") {
            WarningMessage("Please Enter Correct Value")
            return;
        }
        e.preventDefault();
        let data = {
            data: refreshTime
        };
        const timeData = await httpService.CreateUpdate("saveCsvRefreshTime", data)
        if (timeData && timeData.data.ack == "1") {
            SuccessMessage(timeData.data.message)
            getRefreshTime();
            return;
        } else {
            WarningMessage(timeData.data.message)
        }
    };
    return (
        <div style={{ margin: "15px" }}>
           <Navbar activeTab={activeTab} />
                <div className='pad-15 mt-5'>
                <div className="form-boxdiv ">
                    <div className="form-boxtopline5">CSV File Sync Time</div>
                    <div className="form-boxtopcont ">
                        <div className="row">
                            <div className="col-sm-6">
                                <label>Set Time (min):</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Minutes..."
                                    pattern="[1-9]{1}[0-9]{9}"
                                    autoComplete='off'
                                    name="fixtime"
                                    onChange={(e) => { handleTime(e) }}
                                    value={refreshTime}
                                />
                                <Button
                                    color="success"
                                    className='mt-2 mr-2 mb-2'
                                    onClick={(e) => saveRefreshTime(e)}
                                >  Save
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-4"></div>
            <div className="text-end col-4" style={{ marginTop: "15px" }}>
            </div>
        </div>
    )
}
export default CsvFileRefreshTime